module.exports = __webpack_public_path__ + "img/img06.9ac74139.jpg";